module.exports = "/src/views/player/help/images/azart3.jpg";